import { useLayoutEffect, useEffect } from 'react';

var useIsoMorphicEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

export { useIsoMorphicEffect };
//# sourceMappingURL=use-iso-morphic-effect.esm.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@headlessui/react/dist/hooks/use-iso-morphic-effect.esm.js
// module id = 2
// module chunks = 0